import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useVentureId } from '~/functions/accounts';
import { AccountCategory, useGetAccountQuery, useUpdateAccountMutation } from '~/types/types';
export default defineComponent({
  props: {
    name: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    logo: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tooltipDirection: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup() {
    var _useGetAccountQuery = useGetAccountQuery({}, {
        enabled: false
      }),
      result = _useGetAccountQuery.result;
    var ventureId = useVentureId();
    var _useUpdateAccountMuta = useUpdateAccountMutation({}),
      updateAccount = _useUpdateAccountMuta.mutate;
    var _useNuxtApp = useNuxtApp(),
      $axios = _useNuxtApp.$axios;
    var logoUpload = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var _response$data, formData, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (file) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              formData = new FormData();
              formData.append('file', file);
              _context.next = 7;
              return $axios.post('/api/upload', formData, {
                headers: {
                  'content-Type': 'multipart/form-data'
                }
              });
            case 7:
              response = _context.sent;
              if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data[0]) {
                window.$nuxt.$emit('userMsg');
                updateAccount({
                  input: {
                    id: ventureId.value,
                    logo: response.data[0]
                  }
                });
              }
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              window.$nuxt.$emit('userError', _objectSpread(_objectSpread({}, _context.t0), {}, {
                color: 'red'
              }));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 11]]);
      }));
      return function logoUpload(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      logoUpload: logoUpload,
      disabled: computed(function () {
        var _result$value, _result$value$getAcco;
        return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getAcco = _result$value.getAccount) === null || _result$value$getAcco === void 0 ? void 0 : _result$value$getAcco.type) === AccountCategory.Portfolio;
      })
    };
  }
});